import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0466cfff"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "address-list"
};
const _hoisted_2 = {
  class: "pro-box"
};
const _hoisted_3 = {
  class: "texarea"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createTextVNode(" 售后原因 "), /*#__PURE__*/_createElementVNode("span", {
  class: "required"
}, "*")], -1));
const _hoisted_5 = {
  class: "update-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src", "onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  key: 2,
  class: "loading"
};
const _hoisted_10 = ["src", "onClick"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_camera.png",
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createTextVNode(" 上传凭证"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("支持图片/视频 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("（最多6张） ")], -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "update-bt"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_camera.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createTextVNode(" 上传凭证"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("支持图片/视频 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("（最多6张） ")])], -1));
const _hoisted_15 = {
  class: "btn-box"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "是否确认删除该地址", -1));
const _hoisted_17 = {
  class: "bt-box"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bt"
}, "确认", -1));
const _hoisted_19 = {
  class: "dialog",
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "background": "none"
  }
};
const _hoisted_20 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompProCard = _resolveComponent("CompProCard");
  const _component_Field = _resolveComponent("Field");
  const _component_Uploader = _resolveComponent("Uploader");
  const _component_Form = _resolveComponent("Form");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _component_VImage = _resolveComponent("VImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Form, {
    modelValue: $data.from,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.from = $event),
    onSubmit: $options.onSubmit,
    "label-width": "2.1rem"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [$setup.PInfo.id && $setup.PInfo.name && $setup.PInfo.wb_logo_1 ? (_openBlock(), _createBlock(_component_CompProCard, {
      key: 0,
      pro_info: {
        pro_id: $setup.PInfo.id,
        name: $setup.PInfo.name,
        url: $setup.PInfo.wb_logo_1
      }
    }, null, 8, ["pro_info"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_Field, {
      class: "texarea-input",
      modelValue: $data.from.apply_reson_content,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.from.apply_reson_content = $event),
      maxlength: "200",
      "show-word-limit": true,
      rows: "3",
      type: "textarea",
      placeholder: "请您详细填写申诉原因"
    }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, (item, idx) => {
      return _openBlock(), _createElementBlock("div", {
        class: "list",
        key: idx
      }, [_createElementVNode("div", {
        class: "icon-closs delete",
        onClick: _withModifiers($event => $options.deleteImg(idx), ["stop"])
      }, null, 8, _hoisted_6), item.file_type == 'video' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [item.loaded ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.$imgUrlFilter(item.video_cover, Math.round(216 * $data.domPixelRatio())),
        onClick: $event => $options.openBig(item)
      }, null, 8, _hoisted_7)) : _createCommentVNode("", true), item.loaded ? (_openBlock(), _createElementBlock("i", {
        key: 1,
        onClick: $event => $options.openBig(item),
        class: "play-icon"
      }, null, 8, _hoisted_8)) : _createCommentVNode("", true), !item.loaded ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _ctx.$imgUrlFilter(item.url, Math.round(216 * $data.domPixelRatio())),
        onClick: $event => $options.openBig(item)
      }, null, 8, _hoisted_10))]);
    }), 128)), $data.fileList.length < 6 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [$data.env.isModianIos() || $data.env.isModianAndroid() ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "update-bt",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.appUpdate && $options.appUpdate(...args))
    }, _hoisted_13)) : (_openBlock(), _createBlock(_component_Uploader, {
      key: 1,
      deletable: "",
      accept: "image/*, video/*",
      "max-count": "6",
      "after-read": $options.afterRead
    }, {
      default: _withCtx(() => [_hoisted_14]),
      _: 1
    }, 8, ["after-read"]))], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
      class: _normalizeClass(['frombtn', {
        ready: $data.readyBtn
      }]),
      onClick: _cache[2] || (_cache[2] = (...args) => $options.readyBtnSubmit && $options.readyBtnSubmit(...args)),
      round: "",
      block: "",
      type: "primary",
      "native-type": "submit"
    }, " 提交申诉 ", 2)])]),
    _: 1
  }, 8, ["modelValue", "onSubmit"]), _createVNode(_component_van_popup, {
    show: $data.quhao,
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: _ctx.payList,
      onConfirm: $options.onConfirmquhao,
      onCancel: _cache[4] || (_cache[4] = $event => $data.quhao = false)
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.dialogShow,
    onClick: _cache[7] || (_cache[7] = $event => $data.dialogShow = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "dialog",
      onClick: _cache[6] || (_cache[6] = _withModifiers($event => $data.dialogShow = true, ["stop"]))
    }, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", {
      class: "bt",
      onClick: _cache[5] || (_cache[5] = _withModifiers($event => $data.dialogShow = false, ["stop"]))
    }, "取消")])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.dialogImgShow,
    onClick: _cache[9] || (_cache[9] = $event => $data.dialogImgShow = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [$data.imgBigUrl.file_type == 'video' ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
      controls: "",
      muted: "",
      autoplay: "",
      playsinline: "true",
      "webkit-playsinline": "true",
      style: {
        "max-width": "80%",
        "max-height": "60%"
      },
      src: $data.imgBigUrl.videoUrl
    }, null, 8, _hoisted_20)) : (_openBlock(), _createBlock(_component_VImage, {
      key: 1,
      width: "100%",
      fit: "contain",
      src: $data.imgBigUrl.url
    }, null, 8, ["src"]))])]),
    _: 1
  }, 8, ["show"])]);
}